import { client } from "@/hono";
import { DashboardAlerts } from "@/sites/dashboard/dashboard-alerts";
import { ContentBox } from "@msuite/ui/content-box";
import { Dashboard as DashboardUI } from "@msuite/ui/dashboard";
import { LoadingScreen } from "@msuite/ui/loading-screen";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { Dashboard7DaysForecastItem } from "./dashboard-7-days-forecast-item";
import { DashboardAbsencesItem } from "./dashboard-absences-item";
import { DashboardInvoiceApprovalsItem } from "./dashboard-invoice-approvals-item";
import { DashboardMeasurementsItem } from "./dashboard-measurements-item";
import { DashboardPartnerBookingReviewsItem } from "./dashboard-partner-booking-reviews-item";
import { DashboardPartnerBookingsDueItem } from "./dashboard-partner-bookings-due-item";
import { DashboardProtocolsItem } from "./dashboard-protocols-item";
import { DashboardTasksItem } from "./dashboard-tasks-item";
import { DashboardTodayItem } from "./dashboard-today-item";
import { DashboardWeatherItem } from "./dashboard-weather-item";
import { DashboardYearlyStatisticsItem } from "./dashboard-yearly-statistics-item/dashboard-yearly-statistics-item";

export function Dashboard() {
	/** Query */
	const { data } = useQuery({
		queryKey: ["dashboard"],
		queryFn: async () => {
			const response = await client.users.dashboard.$get();
			const json = await responseHandler(response);
			return json;
		},
		staleTime: 10,
	});

	/** Guard */
	if (!data) return <LoadingScreen />;

	/** Render */
	return (
		<ContentBox
			className="sm:px-[10vw] sm:pt-[10vh] pt-[5vh]"
			bottomPadding="none"
		>
			<DashboardUI
				layouts={data.layouts}
				onLayoutChange={() => {}}
				render={(item) => {
					switch (item.i) {
						case "weather":
							return <DashboardWeatherItem item={item} />;
						case "7-days-forecast":
							return <Dashboard7DaysForecastItem item={item} />;
						case "measurements":
							return <DashboardMeasurementsItem item={item} />;
						case "yearly-statistics":
							// No permission check here: the layout is the gate. `getUserDashboard`
							// filters the tiles by the caller's rules, so a caller without
							// `read Invoice` never receives this entry — no empty cell where
							// revenue would stand, and no query fired against a route that would
							// refuse it.
							return <DashboardYearlyStatisticsItem item={item} />;
						case "absences":
							return <DashboardAbsencesItem item={item} />;
						case "my-tasks":
							return <DashboardTasksItem item={item} />;
						case "invoice-approvals":
							// Gated by the layout like the revenue tile: `getUserDashboard` offers it only
							// to a caller with `read IncomingInvoice`.
							return <DashboardInvoiceApprovalsItem item={item} />;
						case "partner-booking-reviews":
							// Gated by the layout: offered only to a caller with `read Partner` whose
							// organisation hosts a partner.
							return <DashboardPartnerBookingReviewsItem item={item} />;
						case "partner-bookings-due":
							// Gated by the layout: offered only to a caller with `read Partner` whose
							// organisation is somebody's partner.
							return <DashboardPartnerBookingsDueItem item={item} />;
						case "protocols":
							return <DashboardProtocolsItem item={item} />;
						case "today":
							return <DashboardTodayItem item={item} />;
						default:
							return null;
					}
				}}
			>
				<DashboardAlerts />
			</DashboardUI>
		</ContentBox>
	);
}
